/* eslint-disable @typescript-eslint/naming-convention */
import { GeneratedTheme, Theme } from '../../types';

import mapDropdownTheme from './mapDropdownTheme';
import mapIconButtonTheme from './mapIconButtonTheme';
import mapListItemTheme from './mapListItemTheme';

type Props = {
  core: Theme['core'];
  semantic: Theme['semantic'];
  components: GeneratedTheme['components'];
};

const mapComponentsTheme = (props: Props): Theme['components'] => {
  const {
    IconButton: _IconButton,
    IconButtonOnElement: _IconButtonOnElement,
    ...rest
  } = props.components;

  return {
    ...rest,
    IconButton: mapIconButtonTheme(props),
    ListItem: mapListItemTheme(props),
    Dropdown: mapDropdownTheme(props),
  };
};

export default mapComponentsTheme;
